import DiagramWithToggleKey from "../shared/DiagramWithToggleKey";
import NutritionOmega3Combined from "./index";

const NutritionOmega3WithToggleKey = props => (
  <DiagramWithToggleKey
    CombinedDiagram={NutritionOmega3Combined}
    keyControlsId="nutrition-omega3-key"
    {...props}
  />
);

export default NutritionOmega3WithToggleKey;
